@if (!showForm()) {

  @if (!data.isSubscriptionExpired) {

    <div class="px-4 py-4 pb-2 border-b border-secondary">

      <h3 class="flex items-center gap-1">
        <b>Welcome to Thelightbulb!</b>
      </h3>

    </div>

    <div class="px-4 pb-6 pt-2">

      <p class="text-gray-500">
        Thank you for signing up! Your account is currently being processed by our team.
      </p>

      <p class="text-gray-500">
        The dashboard will become operational as soon as your account is fully activated,
        typically within 5 business day.
      </p>

      <p class="mt-2">

        Experiencing a delay or believe there's an issue?

        <b
          class="underline hover:cursor-pointer"
          (click)="openForm()"
        >
          Contact Support
        </b>

      </p>

    </div>

  } @else {

    <div class="px-4 py-4 pb-2 border-b border-secondary">

      <h3 class="flex items-center gap-1">

        <mat-icon class="text-red-400">
          info
        </mat-icon>

        <b>Your subscription has expired.</b>

      </h3>

    </div>

    <div class="px-4 pb-6 pt-2">

      <p class="text-gray-500">
        Your subscription has expired and access to the dashboard is currently unavailable.
        To continue using the platform, please renew your subscription.
      </p>

      <p class="mt-2">

        Renew subscription or believe there's an issue?

        <b
          class="underline hover:cursor-pointer"
          (click)="openForm()"
        >
          Contact Us
        </b>

      </p>

    </div>
  }

} @else {

  @if (!dataSent()) {

    <div
      [formGroup]="contactUsForm"
      class="py-4"
    >

      <!-- HEADER -->

      <div class="flex justify-between items-center px-6 py-4 border-b border-b-secondary mb-4">

        <div>

          <h3 class="font-bold">
            Contact us
          </h3>

          <p class="text-sm">
            Fill in the form and our team will be in touch as soon as possible.
          </p>

        </div>

        @if (data.showDialogClose) {

          <mat-icon
            class="hover:cursor-pointer"
            (click)="close()"
          >
            close
          </mat-icon>
        }

      </div>

      <!-- FORM -->

      <div class="px-6">

        <isc-input-control
          label="Full name*"
          placeholder="Enter full name"
          [ispFormControl]="$any(contactUsForm.get('name'))"
          type="text"
          [specialCharacterValidation]="true"
          errorMessage="Please enter full name."
          [maxlength]="100"
          [countChars]="false"
          [bold]="true"
        />

        <isc-input-control
          label="Email"
          placeholder="Email"
          [ispFormControl]="$any(contactUsForm.get('registeredEmail'))"
          type="text"
          [specialCharacterValidation]="true"
          errorMessage="Please enter registered email."
          [maxlength]="100"
          [countChars]="false"
          [bold]="true"
        />

        <isc-input-control
          label="Subject"
          placeholder="Subject"
          [ispFormControl]="$any(contactUsForm.get('subject'))"
          type="text"
          [specialCharacterValidation]="true"
          errorMessage="Please enter subject."
          [maxlength]="100"
          [countChars]="false"
          [bold]="true"
        />

      </div>

      <div class="px-6">

        <isc-textarea-control
          label="Message*"
          placeholder="Enter message"
          [ispFormControl]="$any(contactUsForm.get('message'))"
          [specialCharacterValidation]="true"
          errorMessage="Please enter message."
          [countChars]="true"
          [bold]="true"
          [maxlength]="1000"
        />

      </div>

      <!-- ACTION -->

      <div class="flex justify-end px-6">

        <isc-button
          label="Send"
          [disabled]="
            !!contactUsForm.get('message')?.value &&
            !isMessageValid()
          "
          (onClick)="submitForm()"
        />

      </div>

    </div>

  } @else {

    <div class="p-6">

      <h3 class="text-xl font-bold flex justify-center gap-2 items-center">

        <mat-icon class="text-green-600 w-12 h-12 text-5xl">
          check
        </mat-icon>

        Message sent!

      </h3>

      <p class="text-center text-sm text-gray-400 pb-6 pt-3">

        Thank you for contacting us.
        Our team will be in touch in the next 24 hours.

      </p>

      @if (data.showDialogClose) {

        <div class="flex justify-center">

          <isc-button
            label="Close"
            (onClick)="close()"
          />

        </div>
      }

    </div>
  }
}